import React, { useState} from 'react';
import './Testimonials.css';

const testimonials = [
  { name: 'Saher', message: "Effortless to wear and instantly polished. I didn’t want to take them off." },
  { name: 'Janhavi', message: "They make you feel put together without trying too hard." },
  { name: 'Arshia', message: "So elegant, but actually comfortable enough for a full day." },
  { name: 'Ishita', message: "Surprisingly versatile. I’ve worn them to work and straight out after." },
  { name: 'Shirene', message: "Extremely comfortable. I was honestly shocked by how easy they were to walk in" },
  { name: 'Pavni', message: "This looks crazyyy" }
];

const Testimonials = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="testimonials">
      {/* Main rotating quote */}
      <div className="testimonial-slide fade-in">
        <p className="message">“{testimonials[0].message}”</p>

        <div className="author">
          <span className="name">{testimonials[0].name}</span>
        </div>

        {/* Toggle Button */}
        <button
          className="testimonial-button"
          onClick={() => setExpanded(!expanded)}
        >
          <span>{expanded ? "COLLAPSE STORIES" : "READ MORE STORIES"}</span>
        </button>
      </div>

      {/* Sliding Train Section */}
      {expanded && (
        <div className="train-wrapper">
          <div className="train-track">
            {[...testimonials, ...testimonials].map((t, i) => (
              <div className="train-card" key={i}>
                <p className="train-message">“{t.message}”</p>
                <p className="train-name">— {t.name}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default Testimonials;
